cafm.today = {
    chartTheme: 'bootstrap',
    panelsPerRow: cafm.cache.get('CAFMTodayWidgetsPerRow', 3),
    widgetIntervals: [],
    noDataMessage: 'No Data',
    widgetNameAssetWorkOrderCountTopTen: '',
    init: function () {

        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.CAFMToday);

        // move elements to their target element
        body.addClass('dashboard-page').moveChildren();

        // setup menu handlers and resize events
        cafm.today.handlers.setup();

        // setup widgets per row control
        cafm.today.setupWidgetsPerRow();

        cafm.actions.execute({
          url: cafm.url.api('cafmtoday/getstaticwidgetinfodata'),
          method: 'GET',
          success: function (res, action) {
            cafm.today.widgetNameAssetWorkOrderCountTopTen = res.WidgetNameAssetWorkOrderCountTopTen;
          },
          error: function (r, s, m, action) {
            console.error('\'{0}\' failed when calling getstaticwidgetinfodata'.format(action.description));
          }
        });
        document.title = "CAFM Today - " + cafm.res.str.TitleCafmWeb;
    },
    loadAllWidgets: function (list) {

        list.element.find('> li').each(function (i, li) {

            li = $(li);
            cafm.today.loadWidget(li)
        });
    },
    flushWidgetIntervals: function() {

        if (cafm.today.widgetIntervals) {

            for (var k in cafm.today.widgetIntervals) {

                let interval = cafm.today.widgetIntervals[k];

                if (interval) {
                    clearInterval(interval);
                }
            };

            cafm.today.widgetIntervals = [];
        }
    },
    loadWidget: function(li) {

        var item = li.getListViewDataItem(li.data('id'), 'WidgetDetails.ID'),
            widget = item.WidgetDetails,
            parameters = item.WidgetParameters;

        if (!item.NotAllowed && widget) {

            var interval = cafm.today.widgetIntervals[widget.ID];

            if (interval) {
                clearInterval(interval);
            }

            cafm.actions.execute({
                description: widget.Title,
                element: li,
                loaderTarget: li,
                loaderText: 'Retrieving widget data...',
                url: cafm.url.api('cafmtoday/getwidgetdata'),
                values: cafm.util.idData(widget.ID),
                requestInterval: widget.IsLive && widget.RefreshRate > 0 ? (widget.RefreshRate * 60000) : false,
                suppressErrors: true,
                widget: widget,
                parameters: parameters,
                success: function (res, action) {

                    // attach the parameters to the widget element
                    li.data('parameters', parameters);

                    // render the widget
                    cafm.today.renderWidget({
                        response: res, element: li, widget: action.widget
                    });
                },
                error: function (r, s, m, action) {

                    console.error('\'{0}\' failed when calling getwidgetdata'.format(action.description));
                },
                complete: function (r, s, m, action) {

                    if(action.interval) cafm.today.widgetIntervals[action.values.ID] = action.interval;
                }
            });
        }
    },
    renderWidget: function (args) {

        if (cafm.util.hasItem(args.response)) {
            cafm.util.callFunction('cafm.today.dataRenderers.' + cafm.enums.getEnumKey(cafm.enums.WidgetDisplayTypeData, args.response[0].DisplayType).toLowerCase(), args);
        }
        else {
            args.element.append('<div class="dash-panel-no-data">{0}</div>'.format(cafm.today.noDataMessage));
        }
    },
    setupWidgetsPerRow: function() {

        var widgetsPerRowInput = $('#widgetsPerRow').getNumericTextboxes()[0];
        widgetsPerRowInput.element.prop('readonly', true);
        widgetsPerRowInput.value(cafm.today.panelsPerRow);

        // setup widgets per row change handler - spinner only for now
        widgetsPerRowInput.bind('spin', function (e) {

            cafm.today.panelsPerRow = e.sender.value();
            cafm.cache.set('CAFMTodayWidgetsPerRow', cafm.today.panelsPerRow);
            widgetsPerRowInput.element.blur();
            $('.dashboard').refreshDashPanelLayout();
        });
    },
    settings: {
        bind: function (obj) {
            
            cafm.views.bindActionWindowViewModel(obj);

            var widget = cafm.views.getActionWindowViewModel(), paramDict = {};

            widget.WidgetParameters.forEach(function (p) {

                var values, value, description;
                if (cafm.util.hasItem(p.ParameterValues.ValuesComplex)) {

                    values = cafm.util.transformArray(p.ParameterValues.ValuesComplex, function (vc) {
                        return {
                            text: vc.UIValue,
                            value: vc.RawValue
                        };
                    });

                    description = cafm.util.selectValue(p.ParameterValues.ValuesComplex, 'UIValue').join(', ');
                    value = cafm.util.selectValue(p.ParameterValues.ValuesComplex, 'RawValue');
                }

                if (p.ParameterType == cafm.enums.WidgetParameterType.Date) {

                    paramDict[p.DashboardParameterId] = {
                        _param: p,
                        Description: description,
                        Value: values ? cafm.util.ensureDate(values[0].text) : ''
                    };
                }
                else {

                    paramDict[p.DashboardParameterId] = {
                        _param: p,
                        Description: description,
                        Value: values
                    };
                }
            });

            widget.set({ Parameters: paramDict });
        }
    },
    handlers: {
        setup: function() {
            
            // setup dashboard menu click handler
            $('.dash-menu').on('click.cafmdash', 'a', function (args) {

                var t = $(args.currentTarget), cl = t.attr('class');

                cl.split(' ').forEach(function (c) {

                    if (c.startsWith('dash-')) {

                        c = c.replace('dash-', '').replace(' ', '');
                        cafm.util.callFunction('cafm.today.handlers.actions.' + c, t);
                    }
                });
            }).prepareForm();

            // setup dash panel handlers
            $('.dashboard .cLv').off('click.cafmdash').on('click.cafmdash', 'a', function (args) {

                var t = $(args.currentTarget), cl = t.attr('class');

                cl.split(' ').forEach(function (c) {

                    if (c.endsWith('-dash-panel')) {

                        c = c.replace('-dash-panel', '').replace(' ', '');

                        cafm.util.callFunction('cafm.today.handlers.panel.' + c, t);
                    }
                })
            });

            // setup window resize events
            $(window).on('resize.cafmdash', function () {

                cafm.today.resizeTimeout = setTimeout(function () {

                    if (cafm.today.resizeTimeout) clearTimeout(cafm.today.resizeTimeout);
                    $('.dashboard').refreshDashPanelLayout();
                    delete cafm.today.resizeTimeout;
                }, 12.5);
            });

            $(window).resize(function () {
                $('.dashboard').refreshDashPanelLayout();
            });
        },
        actions: {
            edit: function() {

                $('.dashboard').toggleClass('edit-mode').find('.dash-panel-menu').toggle();
            },
            full: function () {
                
                $('.dashboard').removeClass('edit-mode').find('.dash-panel-menu').hide();
                $('#mainContentPane').viewFullScreen();
            },
            reset: function (link) {

                cafm.util.yesNoDialogue({
                    message: 'Are you sure you want to reset all widgets? All changes will be lost.',
                    messageType: cafm.enums.MessageType.Warning,
                    yesHandler: function () {

                        cafm.actions.execute({
                            loaderSelector: '#dashboard-section',
                            loaderText: 'Resetting all widgets...',
                            url: cafm.url.api('cafmtoday/resetallwidgets'),
                            success: function (res) {
                                var widgetsPerRowInput = $('#widgetsPerRow').getNumericTextboxes()[0];
                                widgetsPerRowInput.value(3);
                                widgetsPerRowInput.trigger('spin');
                                $('#dashboardLv').refreshListDS();
                            }
                        })
                    }
                })
            }
        },
        panel: {
            dataBound: function (args) {

                cafm.today.flushWidgetIntervals();

                cafm.util.callFunctionAsync({
                    func: cafm.today.loadAllWidgets,
                    arg1: args.sender
                });

                args.sender.element.setDashPanelsToFit();
            },
            edit: function (link) {

                cafm.views.openActionWindow({
                    url: cafm.url.get('cafmtoday/editwidget/{0}', link.closest('li').data('id')),
                    isForm: true,
                    winOptions: {
                        width: cafm.views.actionWindowConfig.medium.width(),
                        height: cafm.views.actionWindowConfig.mediumLarge.height()
                    },
                    onInit: function (element) {
                        var tab = element.find('[data-key=Parameters]');
                        tab.find('label[for]').removeAttr('for');
                        tab.find('.cfControl[id]').removeAttr('id');
                    }
                });
            },
            maximise: function (link) {
                $('.dashboard').removeClass('edit-mode').find('.dash-panel-menu').hide();
                link.closest('li').viewFullScreen()
            },
            refresh: function (link) {
                cafm.today.loadWidget(link.closest('li'));
            },
            replace: function (link) {

                var listItem = link.closest('li'),
                    widget = listItem.getListViewDataItem(listItem.data('id'), 'WidgetDetails.ID').WidgetDetails;

                cafm.views.openActionWindow({
                    url: cafm.url.get('cafmtoday/selectwidget/{0}', widget.ID),
                    isForm: true,
                    winOptions: {
                        width: cafm.views.actionWindowConfig.medium.width(),
                        height: cafm.views.actionWindowConfig.mediumLarge.height()
                    },
                    onLoad: function (panel, win) {

                        panel.find('[name="Title"]').data('filterop', cafm.enums.FilterType.Contains);
                        cafm.filters.client.setupFilters(panel.find('fieldset'), panel.find('.cGrd'));
                    }
                });
            }
        },
        replace: {

            cancel: cafm.toolbar.standardActionToolbar.cancel,
            widgetSelected: function (args) {

                var selected = args.sender.element.getSelectedGridRows(),
                    viewModel = $('#replaceWidget').getViewModel(),
                    widget = cafm.util.hasItem(selected) ? selected[0] : '';
                viewModel.set('NewWidgetId', widget.ID);

                $('.actionWindow > .{0}'.format(cafm.res.consts.CssClass_WindowButtons)).remove();

                cafm.actions.execute({
                    url: cafm.url.api('cafmtoday/replaceuserwidget'),
                    loaderSelector: '.actionPanel, .actionWindow [data-key="Cancel"]',
                    values: viewModel,
                    success: function (res) {

                        $('#actionFormPlc').loadView({
                            url: cafm.url.get('cafmtoday/replacewidget', res.WidgetDetails.ID),
                            method: 'POST',
                            values: res,
                            isForm: true,
                            onInit: function (element) {
                                var tab = element.find('[data-key=Parameters]');
                                tab.find('label[for]').removeAttr('for');
                                tab.find('.cfControl[id]').removeAttr('id');
                            },
                            onLoad: function (panel, win) {

                                cafm.util.positionWindowButtons({
                                    container: $('.{0}'.format(cafm.res.consts.CssClass_WindowButtons), panel)
                                });
                                panel.getParentWindow().title('Edit widget settings');
                            }
                        });
                    }
                })
            }
        },
        settings: {
            
            beforeExecute: function (args) {

                var widget = args.values;

                if (widget.Parameters) {

                    for (var name in widget.Parameters) {

                        var p = widget.Parameters[name];

                        if (isObj(p) && p._param) {

                            var wp = cafm.util.find(widget.WidgetParameters, function (wp) { return wp.DashboardParameterId == name });

                            var value, valueComplex;

                            if (isArray(p.Value)) {

                                if (p.Value.length) {

                                    value = cafm.util.selectValue(p.Value, 'value');
                                    valueComplex = cafm.util.transformArray(p.Value, function(v) { return { RawValue: v.value, UIValue: v.text } });
                                }
                                else {

                                    value = [];
                                }
                            }
                            else if (!isNullOrUndefined(p.Value) && isDate(p.Value)) {

                                value = [p.Value];
                                valueComplex = [{ RawValue: p.Value, UIValue: p.Value }];
                            }
                            else if (!isNullOrUndefined(p.Value) && isObj(p.Value)) {

                                value = [cafm.util.getItemValue(p.Value)];
                                valueComplex = [{ RawValue: p.Value.value, UIValue: p.Value.text }];
                            }
                            else {

                                value = p.Value ? [p.Value] : [];
                                valueComplex = [{ RawValue: p.Value, UIValue: undefined }];

                            }

                            wp.ParameterValues.Values = value;
                            wp.ParameterValues.ValuesComplex = valueComplex;
                        }
                    }

                    delete widget.Parameters;
                }
                else if(widget.WidgetParameters) {

                    widget.WidgetParameters.forEach(function (wp) {

                        if (!wp.ParameterValues.Values) wp.ParameterValues.Values = [];
                    });
                }
            },
            submit: function (args) {

                var element = $('#actionFormPlc'),
                    viewModel = element.getViewModel().toJSON();

                cafm.actions.execute({
                    element: element,
                    url: cafm.url.api('cafmtoday/updateuserwidgetsetting'),
                    loaderSelector: '.actionWindow [data-key="Submit"]',
                    values: viewModel,
                    beforeExecute: cafm.today.handlers.settings.beforeExecute,
                    success: function (res, action) {

                        // have to refresh the whole list on replacing as the ID for the replacing widget is not persisted.
                        if (viewModel.WidgetDetails.IsForReplaceAction) {

                            cafm.util.refreshList({
                                listSelector: '#dashboardLv',
                                callback: function () {
                                    $('.dash-panel-menu').show();
                                }
                            });
                        }
                        else {
                            
                            var interval = cafm.today.widgetIntervals[viewModel.WidgetDetails.IdOfReplacedWidget];
                            if (interval) clearInterval(interval);

                            var lv = $('#dashboardLv');
                            // update the list view item
                            lv.getListViewDataItem(viewModel.WidgetDetails[viewModel.WidgetDetails.IsForReplaceAction ? 'IdOfReplacedWidget' : 'ID'], 'WidgetDetails.ID').set(action.executedValues);
                            // reapply panel styles
                            lv.setDashPanelsToFit();
                            // reload widget
                            cafm.today.loadWidget(lv.find('.dash-panel[data-id="{0}"]'.format(viewModel.WidgetDetails.ID)));
                            // show the dash panel menu
                            $('.dash-panel-menu').show();
                        }


                        cafm.views.closeActionWindow();
                    }
                })
            },
            cancel: cafm.toolbar.standardActionToolbar.cancel
        }
    },
    dataRenderers: {

        barchart: function(args) {

            var existing = args.element.find('> div.k-chart');
            if (existing.length) {
                cafm.util.kendoDestroy(existing);
                existing.remove();
            }

            var lcContainer = $('<div/>').appendTo(args.element),
                series = [], categories;

            if (!cafm.util.hasItem(args.response[0].DataSeries)) {

                lcContainer.append('<div class="dash-panel-no-data">{0}</div>'.format(cafm.today.noDataMessage))
                return;
            }

            args.response[0].DataSeries.forEach(function (ds) {

                if (!categories) categories = cafm.util.selectValue(ds.Data, 'Key');

                series.push({
                    name: 'Count',
                    data: cafm.util.transformArray(ds.Data, function (_d) { return { value: _d.Value, color: _d.ColourHtml } })
                });
            });
            
            var maxVal = 0;
            $.each(series, function (i, s) {

                $.each(s.data, function (i, d) {

                    var v = d.value;

                    if (isNum(v) && v > maxVal) {

                        maxVal = v;
                    }
                });
            })

            var majorUnit = maxVal <= 50 ? 10 : maxVal <= 100 ? 25 : (args.element.closest('.dash-panel').width() < 380 && maxVal > 350) || maxVal > 550 ? 100 : 50;

            lcContainer.kendoChart({
                theme: cafm.today.chartTheme,
                chartArea: {
                    background: ''
                },
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "bar",
                    style: "smooth"
                },
                series: series,
                seriesClick: function (e) {

                    if (args.widget.IsLive) cafm.today.dataHandlers.barchart(e, args)
                },
                valueAxis: {
                    line: {
                        visible: false
                    },
                    majorUnit: majorUnit,
                    labels: {
                        font: "11px Arial,Helvetica,sans-serif"
                    }
                },
                categoryAxis: {
                    categories: categories,
                    labels: {
                        font: "11px Arial,Helvetica,sans-serif"
                    }
                },
                tooltip: {
                    visible: true,
                    template: "#: category #: #= value #"
                }
            });

            lcContainer.setDashPanelChartSize();
        },
        columnchart: function (args) {

            var existing = args.element.find('> div.k-chart');
            if (existing.length) {
                cafm.util.kendoDestroy(existing);
                existing.remove();
            }

            var lcContainer = $('<div/>').appendTo(args.element),
                series = [], categories = [];

            if (!cafm.util.hasItem(args.response[0].DataSeries)) {

                lcContainer.append('<div class="dash-panel-no-data">{0}</div>'.format(cafm.today.noDataMessage))
                return;
            }
            
            args.response[0].DataSeries.forEach(function (d) {

                categories.push(d.Title);

                // reformat series data into compatible format
                d.Data.forEach(function (_d) {

                    var key = _d.Key;
                    var seriesItem = cafm.util.find(series, function (_s) { return _s.name == _d.Key });

                    if (seriesItem) {

                        seriesItem.data.push({ value: _d.Value, color: _d.ColourHtml });
                    }
                    else {

                        series.push({

                            name: _d.Key,
                            color: _d.ColourHtml,
                            data: [{ value: _d.Value, color: _d.ColourHtml }]
                        })
                    }
                    
                });
            });

            var maxVal = 0;
            $.each(series, function (i, s) {

                $.each(s.data, function (i, d) {

                    var v = d.value;

                    if (isNum(v) && v > maxVal) {

                        maxVal = v;
                    }
                });
            });

            var majorUnit = maxVal <= 50 ? 10 : maxVal <= 100 ? 25 : (args.element.closest('.dash-panel').height() < 230 && maxVal > 350) || maxVal > 500 ? 100 : 50;

            lcContainer.kendoChart({
                theme: cafm.today.chartTheme,
                chartArea: {
                    background: ''
                },
                legend: {
                    visible: true,
                    position: 'bottom'
                },
                seriesDefaults: {
                    type: 'column',
                    style: 'smooth'
                },
                series: series,
                seriesClick: function (e) {

                    if (args.widget.IsLive) cafm.today.dataHandlers.columnchart(e, args)
                },
                valueAxis: {
                    line: {
                        visible: false
                    },
                    majorUnit: majorUnit,
                    labels: {
                        font: "11px Arial,Helvetica,sans-serif"
                    }
                },
                categoryAxis: {
                    categories: categories,
                    labels: {
                        font: "11px Arial,Helvetica,sans-serif"
                    }
                },
                tooltip: {
                    visible: true,
                    template: "#: category #: #= value #"
                }
            });

            lcContainer.setDashPanelChartSize();
        },
        linechart: function (args) {

            var existing = args.element.find('> div.k-chart');
            if (existing.length) {
                cafm.util.kendoDestroy(existing);
                existing.remove();
            }

            var lcContainer = $('<div/>').appendTo(args.element),
                series = [], categories;

            if (!cafm.util.hasItem(args.response[0].DataSeries)) {

                lcContainer.append('<div class="dash-panel-no-data">{0}</div>'.format(cafm.today.noDataMessage))
                return;
            }
            
            args.response[0].DataSeries.forEach(function (d) {

                if (!categories) categories = cafm.util.selectValue(d.Data, 'Key');

                series.push({
                    name: 'Count',
                    data: cafm.util.selectValue(d.Data, 'Value'),
                    color: d.Data ? d.Data[0].ColourHtml : ''
                });
            });

            var maxVal = 0;
            $.each(series, function (i, s) {

                $.each(s.data, function (i, d) {
                    
                    if (d > maxVal) {

                        maxVal = d;
                    }
                });
            })

            var majorUnit = maxVal <= 50 ? 10 : maxVal <= 100 ? 25 : (args.element.closest('.dash-panel').height() < 230 && maxVal > 450) || maxVal > 600 ? 100 : 50;

            lcContainer.kendoChart({
                theme: cafm.today.chartTheme,
                chartArea: {
                    background: ''
                },
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "line",
                    style: "smooth"
                },
                series: series,
                seriesClick: function (e) {

                    if (args.widget.IsLive) cafm.today.dataHandlers.linechart(e, args)
                },
                valueAxis: {
                    line: {
                        visible: false
                    },
                    majorUnit: majorUnit,
                    labels: {
                        font: "11px Arial,Helvetica,sans-serif"
                    }
                },
                categoryAxis: {
                    categories: categories,
                    labels: {
                        font: "11px Arial,Helvetica,sans-serif"
                    }
                },
                tooltip: {
                    visible: true,
                    template: "#: category #: #= value #"
                }
            });

            lcContainer.setDashPanelChartSize();
        },
        piechart: function (args) {

            var existing = args.element.find('> div.k-chart');
            if (existing.length) {
                cafm.util.kendoDestroy(existing);
                existing.remove();
            }

            var lcContainer = $('<div/>').appendTo(args.element),
                    series = [];

            if (!cafm.util.hasItem(args.response[0].DataSeries)) {

                lcContainer.append('<div class="dash-panel-no-data">{0}</div>'.format(cafm.today.noDataMessage))
                return;
            }

            args.response[0].DataSeries.forEach(function (ds) {
                
                ds.Data.forEach(function (d) {

                    series.push({
                        category: d.Key,
                        value: d.Value,
                        color: d.ColourHtml
                    });
                })
            });

            lcContainer.kendoChart({
                theme: cafm.today.chartTheme,
                chartArea: {
                    background: ''
                },
                legend: {
                    visible: true,
                    labels: {
                        template: "#= kendo.toString(cafm.today.getReasonName(text))#"                      
                    }
                   
                },
                seriesDefaults: {
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#=value#",
                        position: 'center'
                    }
                },
                series:[{
                    type: "pie",
                    startAngle: 180,
                    data: series
                }],
                seriesClick: function (e) {

                    if (args.widget.IsLive) cafm.today.dataHandlers.piechart(e, args)
                },
                valueAxis: {
                    labels: {
                        font: "11px Arial,Helvetica,sans-serif"
                    }
                },
                tooltip: {
                    visible: true,
                    template: "#= kendo.toString(cafm.today.getReasonName(category + ' :' + value))#"
                }
            });

            lcContainer.setDashPanelChartSize();
        },
        tabulardataboxes: function (args) {

            args.element.find('> .dash-panel-table-container').remove();

            var tableContainer = $('<div/>', { 'class': 'dash-panel-table-container' }).appendTo(args.element),
                table = $('<table/>', { 'class': 'dash-panel-tabular-box' }).appendTo(tableContainer),
                tbody = $('<tbody/>').appendTo(table),
                tr;

            args.response[0].DataSeries.forEach(function (ds) {

                if(!tr) tr = $('<tr/>').appendTo(tbody);
                $('<td/>', { text: ds.Data[0].Value, 'class': 'dash-panel-value-cell dash-panel-value-linked-cell', title: '{0}: {1}'.format(ds.Title, ds.Data[0].Value) }).appendTo(tr);
            });

            tr = null;
            
            args.response[0].DataSeries.forEach(function (ds) {

                if (!tr) tr = $('<tr/>').appendTo(tbody);
                $('<td/>', { text: ds.Title, 'class': 'dash-panel-label-cell' }).appendTo(tr);
            });

            tableContainer.setDashPanelTableSizeAndPosition();

            if (args.widget.IsLive)
                args.element.off('click.cafm').on('click.cafm', '.dash-panel-value-cell', function (e) {

                    cafm.today.dataHandlers.tabulardataboxes(e, args);
                })
        },
        tabulardatagrouped: function (args) {

            args.element.find('> .dash-panel-table-container').remove();

            var tableContainer = $('<div/>', { 'class': 'dash-panel-table-container' }).appendTo(args.element);

            args.response.forEach(function (group) {

                var table = $('<table/>', { 'class': 'dash-panel-tabular-grouped' }).appendTo(tableContainer),
                    tbody = $('<tbody/>').appendTo(table);

                var tr = $('<tr/>').appendTo(tbody),
                    th = $('<th/>', { rowspan: group.DataSeries.length, text: group.Title }).appendTo(tr);
                
                for (var i = 0; i < group.DataSeries.length; i++) {

                    if (i > 0) tr = $('<tr/>').appendTo(tbody);

                    var ds = group.DataSeries[i];

                    $('<td/>', { text: ds.Title, 'class': 'dash-panel-label-cell' }).appendTo(tr);
                                      
                    $('<td/>', { 'data-title': ds.Title, text: ds.Data[0].Value, 'class': 'dash-panel-value-cell dash-panel-value-linked-cell', title: '{0}: {1}'.format(ds.Title, ds.Data[0].Value) }).appendTo(tr);
                                        
                }
            })

            if (args.widget.IsLive)
                args.element.off('click.cafm').on('click.cafm', '.dash-panel-value-cell', function (e) {

                    cafm.today.dataHandlers.tabulardatagrouped(e, args);
                })

            tableContainer.setDashPanelTableSizeAndPosition();
        },
        tabulardatasimple: function(args) {

            args.element.find('> .dash-panel-table-container').remove();

            var tableContainer = $('<div/>', { 'class': 'dash-panel-table-container' }).appendTo(args.element),
                table = $('<table/>', { 'class': 'dash-panel-tabular-simple' }).appendTo(tableContainer),
                tbody = $('<tbody/>').appendTo(table);

            args.response.forEach(function (res) {

                var tr = $('<tr/>').appendTo(tbody);
                $('<td/>', { html: '<span class="dash-panel-cell-text" title="{0}">{0}</span>'.format(res.Title), 'class': 'dash-panel-label-cell' }).appendTo(tr);

                res.DataSeries.forEach(function (ds) {

                  $('<td/>', { html: '<span class="dash-panel-cell-text" title="{0}">{0}</span>'.format(ds.Title), 'class': 'dash-panel-label-cell' }).appendTo(tr);

                  if (args.widget.WidgetName == cafm.today.widgetNameAssetWorkOrderCountTopTen) {
                    var assetId = ds.Data[0].UniqueRowId;
                    $('<td/>', { html: '<span class="dash-panel-cell-text" title="{0}">{0}</span>'.format(ds.Data[0].Value), 'data-assetId': assetId, 'class': 'dash-panel-value-cell dash-panel-value-linked-cell' }).appendTo(tr);
                  } else {
                    $('<td/>', { html: '<span class="dash-panel-cell-text" title="{0}">{0}</span>'.format(ds.Data[0].Value), 'class': 'dash-panel-value-cell' }).appendTo(tr);
                  }

                });
          });

          if (args.widget.IsLive)
            args.element.off('click.cafm').on('click.cafm', '.dash-panel-value-cell', function (e) {

              cafm.today.dataHandlers.tabulardatasimple(e, args);
            })

            tableContainer.setDashPanelTableSizeAndPosition();
        },
        trafficlight: function (args) {

            args.element.find('> .tl-container').remove();

            var tlContainer = $('<div/>', {
                    'class': 'tl-container'
                }).appendTo(args.element),
                tlInner = $('<ul/>', {
                    'class': 'tl-inner'
                }).appendTo(tlContainer);

            var i = 0,
                map = [cafm.enums.AlertStatus.Red, cafm.enums.AlertStatus.Amber, cafm.enums.AlertStatus.Green];   

            args.response[0].DataSeries.forEach(function (d) {
             
                var trafficLight = $('<li/>', {
                    'class': 'tl-' + d.Title.toLocaleLowerCase(),
                    html: '<span class="tl-text">' + d.Data[0].Value + '</span>',
                    title: '{0}: {1}'.format(d.Title, d.Data[0].Value),
                    'data-value': map[i++]
                }).appendTo(tlInner)

                if (args.widget.IsLive) trafficLight.click(cafm.today.dataHandlers.trafficlight);

                var tooltip = trafficLight.kendoTooltip({
                    autoHide: true,
                    shared: true,
                    content: function () {
                        return '{0}: {1}'.format(d.Title, d.Data[0].Value);
                    },
                    show: function () {
                        var kt;
                        if ($('.k-tooltip:visible').length > 1) $('.k-tooltip').hide();
                        tooltip.show();
                    },
                    width: 80,
                    position: 'right'
                }).getKendoTooltip();
            });

            tlContainer.setDashPanelTrafficLightSize();
        }
    },
    dataHandlers: {

        barchart: function (args, widgetArgs) {

            var status = args.category ? args.category.toLowerCase().replace(/\s/g, '') : null;

            if (status) {

                var args = {
                    'DrillThroughType': cafm.enums.WorkOrderDrillThroughSearch.PlannedWorkOrdersPerformanceLastMonth
                }

                var lcs, route;
                if ((lcs = cafm.util.getProperty(cafm.enums.LifeCycleStatus, status))) {

                    route = cafm.hd.nav.routes().HelpdeskDrillThroughSearchByStatus;
                    args.Status = lcs;
                }
                else {

                    route = cafm.hd.nav.routes().HelpdeskDrillThroughSearchBySla;
                    args.WithinSla = status;
                }                
                
                cafm.today.hdDrillThrough(route, args, widgetArgs.element);
            }
        },
        columnchart: function (args, widgetArgs) {

            var period = args.category,
                withinSla = args.series.name,
                map = {
                    '6494fce5-44d3-450f-8318-1dec33ce7522': cafm.enums.WorkOrderDrillThroughSearch.ReactiveWorkOrdersClosedBySLAPerformance,
                    '11104a64-3d82-49ec-8c19-0da470198851': cafm.enums.WorkOrderDrillThroughSearch.OverdueWorkOrders
                },
                type = map[widgetArgs.element.data('widgetid')];

            if (type && period) {

                var route = type == cafm.enums.WorkOrderDrillThroughSearch.ReactiveWorkOrdersClosedBySLAPerformance ?
                    cafm.hd.nav.routes().HelpdeskDrillThroughSearchByPeriodAndSla : cafm.hd.nav.routes().HelpdeskDrillThroughSearchByPeriod;
                
                cafm.today.hdDrillThrough(route, {
                    'DrillThroughType': type,
                    'Period': period.replace(/\s/g, '').toLowerCase(),
                    'WithinSla': withinSla ? withinSla.replace(/\s/g, '').toLowerCase() : null
                }, widgetArgs.element);
            }
        },
        linechart: function (args, widgetArgs) {

            var month = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].indexOf(args.category.toLowerCase()) + 1;

            if (month) {
                
                cafm.today.hdDrillThrough(cafm.hd.nav.routes().HelpdeskDrillThroughSearchByMonth, {
                    'DrillThroughType': cafm.enums.WorkOrderDrillThroughSearch.ReactiveWorkOrdersLogged,
                    'Month': month
                }, widgetArgs.element);
            }
        },
        piechart: function (args, widgetArgs) {
            var status, onHoldReason,onHoldReasonName;
                map = {
                    '07875a58-51b0-46dd-8567-449c19394fde': cafm.enums.WorkOrderDrillThroughSearch.PlannedWorkOrdersLoggedThisMonthByStatus,
                    '99199ad9-3395-4745-8b03-11b1dc895aa6': cafm.enums.WorkOrderDrillThroughSearch.ReactiveWorkOrdersLoggedTodayByStatus,
                    'b4290577-d563-46b7-af93-dc8d2c5ab40a': cafm.enums.WorkOrderDrillThroughSearch.ReactiveWorkOrdersLoggedThisWeekByStatus,
                    'e3272285-19d2-4e28-b0a0-d061c96cae79': cafm.enums.WorkOrderDrillThroughSearch.ReactiveWorkOrdersLoggedThisMonthByStatus,
                    'e9e4e8cb-90d5-4eae-8d09-5d901ea546cb': cafm.enums.WorkOrderDrillThroughSearch.WorkOrdersOnHoldByReason
                },
                type = map[widgetArgs.element.data('widgetid')];

            if (type === cafm.enums.WorkOrderDrillThroughSearch.WorkOrdersOnHoldByReason) {
                onHoldReason = args.dataItem.category ? args.dataItem.category.toLowerCase().replace(/\s/g, '') : null;
                onHoldReason = onHoldReason.replace(/\|.*/, "");

                onHoldReasonName = args.dataItem.category.replace(/.*\|/, "");
            }
            else {
                status = args.dataItem.category ? args.dataItem.category.toLowerCase().replace(/\s/g, '') : null;
            }

            if (type && status) {
                cafm.today.hdDrillThrough(cafm.hd.nav.routes().HelpdeskDrillThroughSearchByStatus, {
                    'DrillThroughType': type,
                    'Status': cafm.util.getProperty(cafm.enums.LifeCycleStatus, status)
                }, widgetArgs.element);
            }
            else if (type && onHoldReason) {
                cafm.today.hdDrillThrough(cafm.hd.nav.routes().HelpdeskDrillThroughSearchByOnHoldReason, {
                    'DrillThroughType': type,
                    'OnHoldReason': onHoldReason,
                    'onHoldReasonName': onHoldReasonName
                }, widgetArgs.element);
            }
        },
        tabulardataboxes: function (e, widgetArgs) {

            var element = $(e.currentTarget),
                period = ['today', 'thisweek', 'thismonth'][element.parent().children().index(element)];

            if (period) {
                
                cafm.today.hdDrillThrough(cafm.hd.nav.routes().HelpdeskDrillThroughSearchByPeriod, {
                    'DrillThroughType': cafm.enums.WorkOrderDrillThroughSearch.ReactiveWorkOrderVolumes,
                    'Period': period
                }, element);
            }
      },

      tabulardatasimple: function (e, widgetArgs) {
        var element = $(e.currentTarget);
        if (widgetArgs.widget.WidgetName == cafm.today.widgetNameAssetWorkOrderCountTopTen) {
          var assetId = element.data('assetid');
          if (assetId === undefined) {
            return;
          }
          cafm.today.assetDrillThrough(assetId);
        }

      },

        tabulardatagrouped: function (e, widgetArgs) {

          var element = $(e.currentTarget);
            
          title = element.data('title').replace(/\s/g, '').toLowerCase(),
              routeArgs = {
                  'DrillThroughType': cafm.enums.WorkOrderDrillThroughSearch.WorkOrders
              };

          switch (title) {

              case 'loggedtoday':
              case 'resolvedtoday':
              case 'completedtoday':

                  routeArgs.VolumeType = title;
                  route = cafm.hd.nav.routes().HelpdeskDrillThroughSearchByVolumeType;
                  break;

              case 'open':
              case 'onhold':
              case 'notificationdue':

                  routeArgs.Status = cafm.util.getProperty(cafm.enums.LifeCycleStatus, title);
                  route = cafm.hd.nav.routes().HelpdeskDrillThroughSearchByStatus;
                  break;

              case 'redalert':
              case 'amberalert':
              case 'reviewalert':

                  routeArgs.AlertType = title;
                  route = cafm.hd.nav.routes().HelpdeskDrillThroughSearchByAlertType;
                  break;

              default:

                  return;
          }

              cafm.today.hdDrillThrough(route, routeArgs, element);
           
               
        },
        trafficlight: function (e) {

            cafm.today.hdDrillThrough(cafm.hd.nav.routes().HelpdeskDrillThroughSearchByStatus, {
                'DrillThroughType': cafm.enums.WorkOrderDrillThroughSearch.OverdueWorkOrderAlerts,
                'Status': $(e.currentTarget).data('value')
            }, e.currentTarget)          
        }
    },
    hdDrillThrough: function (route, routeArgs, element) {

        var panel = $(element).closest('.dash-panel');
        
        $.extend(routeArgs, {
            Parameters: panel.data('parameters'),
            SearchTitle: panel.find('h2').text()
        })

        cafm.cache.session.set('cafm.today.drillThroughParameters', routeArgs);
        console.log(cafm.util.transformArray(panel.data('parameters'), function (p) { return '{0} - {1}'.format(p.ParameterName, p.ParameterType); }).join(', '));        
        cafm.url.set('~/helpdesk#' + route.path.routeFormat(routeArgs));        
    },
    drillThroughParameters: function () {

        return cafm.today.drillThroughParameters;
    },
    getReasonName: function (value) {
        return value.replace(/.*\|/, "");
    },
    assetDrillThrough: function (assetId) {
        cafm.url.set('~/assets/asset/' + assetId);        
    }
}

$.fn.setDashPanelsToFit = function () {

    var panels = this.find('.dash-panel:visible');

    if (panels.length) {

        panels.each(function (i, p) {

            if ((i + 1) % cafm.today.panelsPerRow == 0) {
                $(p).css('margin-right', '0');
            }
            else {
                $(p).css('margin-right', '10px');
            }
        });

        var dashPanelWidth = Math.floor(($('#dashboard-section').width() - ((cafm.today.panelsPerRow - 1) * 10)) / cafm.today.panelsPerRow),
            rows = Math.ceil(panels.length / cafm.today.panelsPerRow),
            dashPanelHeight = Math.floor(($('#mainContentPane').height() - ((rows + 1) * 10)) / rows);

        panels.css({
            width: dashPanelWidth + 'px',
            height: dashPanelHeight + 'px'
        });
    }
}
$.fn.refreshDashPanelLayout = function () {
    
    this.each(function (i, element) {

        element = $(element);

        element.setDashPanelsToFit();
        element.find('.dash-panel-table-container').setDashPanelTableSizeAndPosition();
        element.find('.k-chart').setDashPanelChartSize();
        element.find('.tl-container').setDashPanelTrafficLightSize();
    });
    return this;
}
$.fn.setDashPanelTableSizeAndPosition = function () {

    this.each(function (i, element) {

        element = $(element);

        var dashPanel = element.closest('.dash-panel'),
            heading = dashPanel.find('> h2'),
            table = element.find('table:first'),
            simpleTable = table.hasClass('dash-panel-tabular-simple');

        if (simpleTable) {

            var tds = table.find('td'),
                firstTd = tds.first(),
                tdHeight =  (dashPanel.height() - heading.outerHeight() - (parseInt(dashPanel.css('padding-top')) + parseInt(dashPanel.css('padding-bottom')))) / table.find('tr').length -
                            (parseInt(firstTd.css('padding-top')) + parseInt(firstTd.css('padding-bottom'))) -
                            (30 / tds.length);

            tds.height(tdHeight);
        }

        var rowCount = table[0].rows.length;
        var marginTop = ((((simpleTable ? table : element).height() / 2) - (heading.length ? heading.height() : 0) - 5) * -1);
        var fontSize = 93;

        if (rowCount == 10) {
            if (marginTop < -55) {
                marginTop = marginTop + 5;
            }
            fontSize = 75;
        }

        element.css({
            position: 'absolute',
            top: '50%',
            'margin-top': marginTop + 'px',
            width: dashPanel.width(),
            'font-size': fontSize + '%'
        });
    });
    return this;
}
$.fn.setDashPanelChartSize = function () {

    this.each(function (i, element) {

        element = $(element);

        var dashPanel = element.closest('.dash-panel'),
            heading = dashPanel.find('> h2'),
            chart = element.getKendoChart();

        element.css({
            height: (dashPanel.height() - (heading.length ? heading.height() : 0)) + 'px'
        });

        chart.resize();
    });
    return this;
}
$.fn.setDashPanelTrafficLightSize = function () {

    this.each(function (i, element) {

        element = $(element);

        var dashPanel = element.closest('.dash-panel'),
            heading = dashPanel.find('> h2'),
            panelHeight = dashPanel.height(),
            lightDimension = ((panelHeight - heading.height() - 70) / 3),
            dph = dashPanel.height();
        
        if (dph < 600 && lightDimension > 84) lightDimension = 84;
        if (dph > 600 && dph < 800 && lightDimension > 150) lightDimension = 150;
        if (dph > 800 && lightDimension > 200) lightDimension = 200;
        else if (panelHeight > 188 && lightDimension < 32) lightDimension = 32;
        else if (lightDimension < 28) lightDimension = 28;

        element.find('li').css({
            width: lightDimension + 'px',
            height: lightDimension + 'px',
            'border-radius': (lightDimension / 2) + 'px'
        });

        element.find('.tl-text').css({
            'line-height': lightDimension + 'px'
        });

        element.css({
            position: 'absolute',
            top: '50%',
            left: '50%',
            'margin-top': ((element.outerHeight() - heading.height() - 5) / 2) * -1 + 'px',
            'margin-left': (element.width() / 2 * -1) + 'px'
        });
    });
    return this;
}
